import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiRequests from "../../Component/axios/config/config";
import Loading from "../../Component/Loading/Loading";
import { Pencil, Trash2, Eye, EyeOff, X } from "lucide-react";
import { MdArrowBack, MdKeyboardArrowDown } from "react-icons/md";
import toast from "react-hot-toast";

export default function SellerDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [User, setUser] = useState({
    userId: "",
    userName: "",
    email: "",
    address: "",
    mobile: "",
    bankAccountNumber: "",
    immigrationStatus: "",
    immigrationDocument: null,
    status: "",
    storeName: "",
    bio: "",
    Type: "",
    expire: "",
  });

  const [profilePreview, setProfilePreview] = useState("");
  const [headerPreview, setHeaderPreview] = useState("");

  const [loading, setLoading] = useState(true);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [zoomedImage, setZoomedImage] = useState("");

  const statusOptions = [
    { value: "pending", label: "Pending" },
    { value: "accepted", label: "Accepted" },
    { value: "rejected", label: "Rejected" },
  ];

  useEffect(() => {
    setLoading(true);
    apiRequests
      .get(`/api/seller/v1/get-seller-profile/${id}`)
      .then((response) => {
        const info = response.data.data;
        console.log(info);
        setUser({
          userId: id,
          userName: info.userName || "",
          email: info.email || "",
          address: info.address || "",
          mobile: info.mobile || "",
          bankAccountNumber: info.bankAccountNumber || "",
          immigrationStatus: info.immigrationStatus || "",
          immigrationDocument: info.immigrationDocument?.path
            ? `${process.env.REACT_APP_API_URL_IMAGE}${info.immigrationDocument.path}`
            : null,
          status: info.status || "",
          storeName: info.nextStoreName || "",
          bio: info.nextbio || "",
          Type: info.Type || "",
          expire: info.expire ? info.expire.split("T")[0] : "",
        });

        setProfilePreview(
          info.profileImage?.path
            ? `${process.env.REACT_APP_API_URL_IMAGE}${info.profileImage.path}`
            : "",
        );

        setHeaderPreview(
          info.header?.path
            ? `${process.env.REACT_APP_API_URL_IMAGE}${info.header.path}`
            : "",
        );
      })
      .catch((error) => {
        toast.error("Failed to load seller data");
        console.error(error);
      })
      .finally(() => setLoading(false));
  }, [id]);

  function EditUser() {
    setLoadingEdit(true);

    // apiRequests.patch(`/api/seller/v1/edit-seller-by-admin`, {
    //   sellerId: User.userId,
    //   status: User.status,
    // })

    apiRequests
      .patch(`/api/seller/v1/update-seller-status-by-admin`, {
        id: User.userId,
        status: User.status,
      })
      .then(() => {
        toast.success("Seller status updated!");
      })
      .catch((error) => {
        console.log(error.response?.data || error);
        toast.error("Failed to update status");
      })
      .finally(() => setLoadingEdit(false));
  }
  function openZoom(src) {
    setZoomedImage(src);
    setShowImageModal(true);
  }

  if (loading)
    return (
      <div className="p-12">
        <Loading />
      </div>
    );
  if (!User)
    return (
      <div className="text-center font-bold text-xl text-gray-500 mt-20">
        Seller not found
      </div>
    );

  return (
    <div className="max-w-6xl mx-auto">
      <div className="bg-white p-6">
        <div className="flex flex-col gap-8">
          <div className="p-4 flex flex-col rounded-xl gap-2 border border-gray-200 bg-gray-100">
            <h2 className="text-firstColor-shade9 text-2xl font-bold">
              Seller Information
            </h2>

            <div className="grid grid-cols-2 md:flex md:flex-col auto-cols-auto gap-5">
              <DetailItem label="Username">
                <span className="py-1 pl-2 block w-full text-black">
                  {User.userName || "-"}
                </span>
              </DetailItem>

              <DetailItem label="Mobile">
                <span className="py-1 pl-2 block w-full text-black">
                  {User.mobile || "-"}
                </span>
              </DetailItem>
              <DetailItem label="Nationality">
                <span className="py-1 pl-2 block w-full text-black">
                  {User.nationality || "-"}
                </span>
              </DetailItem>

              <DetailItem label="Address">
                <span className="py-1 pl-2 block w-full text-black">
                  {User.address || "-"}
                </span>
              </DetailItem>

              <DetailItem label="Email">
                <span className="py-1 pl-2 block w-full text-black">
                  {User.email || "-"}
                </span>
              </DetailItem>

              <DetailItem label="Bank Account Number">
                <span className="py-1 pl-2 block w-full text-black">
                  {User.bankAccountNumber || "-"}
                </span>
              </DetailItem>
              <DetailItem label="Seller Type">
                <span className="py-1 pl-2 block w-full text-black">
                  {User.Type || "-"}
                </span>
              </DetailItem>

              <DetailItem label="Immigration Status">
                <span className="py-1 pl-2 block w-full text-black">
                  {User.immigrationStatus || "-"}
                </span>
              </DetailItem>
              <DetailItem label="Expire Date">
                <span className="py-1 pl-2 block w-full text-black">
                  {User.expire || "-"}
                </span>
              </DetailItem>

              <DetailItem label="Immigration Document">
                {User.immigrationDocument ? (
                  <img
                    src={User.immigrationDocument}
                    alt="Immigration document"
                    onClick={() => openZoom(User.immigrationDocument)}
                    className="w-full max-h-96 object-contain rounded cursor-zoom-in hover:opacity-90 transition"
                  />
                ) : (
                  <span className="py-1 pl-2 block w-full text-gray-400">
                    No document uploaded
                  </span>
                )}
              </DetailItem>

              <DetailItem label="Status">
                <div
                  className="relative w-full"
                  onClick={() => setOpenStatus((prev) => !prev)}
                >
                  <div className="py-1 pl-2 flex justify-between items-center w-full text-black cursor-pointer">
                    <span>
                      {statusOptions.find((opt) => opt.value === User.status)
                        ?.label || "Select status"}
                    </span>
                    <MdKeyboardArrowDown className="h-5 w-5 text-gray-500" />
                  </div>

                  {openStatus && (
                    <ul className="absolute top-full left-0 mt-2 w-full bg-white border border-gray-300 rounded-lg shadow-lg z-30">
                      {statusOptions.map((option) => (
                        <li
                          key={option.value}
                          onClick={(e) => {
                            e.stopPropagation();
                            setUser({ ...User, status: option.value });
                            setOpenStatus(false);
                          }}
                          className="py-2 px-3 cursor-pointer text-gray-700 hover:bg-gray-100 border-b border-gray-200 last:border-b-0"
                        >
                          {option.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </DetailItem>
            </div>
          </div>

          <div className="p-4 flex flex-col rounded-xl gap-2 border border-gray-200 bg-gray-100">
            <h2 className="text-firstColor-shade9 text-2xl font-bold">
              Shop Information
            </h2>

            <div className="relative mb-10">
              <div className="relative h-72 rounded-3xl overflow-hidden  border-4 border-white">
                {headerPreview ? (
                  <img
                    src={headerPreview}
                    alt="Header"
                    onClick={() => openZoom(headerPreview)}
                    className="w-full h-full object-cover cursor-zoom-in hover:opacity-90 transition"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-gray-400">
                    No Header Image
                  </div>
                )}
              </div>

              <div className="absolute -bottom-16">
                {profilePreview ? (
                  <img
                    src={profilePreview}
                    alt="Profile"
                    onClick={() => openZoom(profilePreview)}
                    className="w-32 h-32 rounded-full object-cover border-4 border-white cursor-zoom-in hover:opacity-90 transition"
                  />
                ) : (
                  <div className="w-32 h-32 rounded-full bg-[#efe5df] border-4 border-white flex items-center justify-center text-gray-400">
                    Profile
                  </div>
                )}
              </div>

              <div className="h-20" />
            </div>

            <div className="grid grid-cols-2 mt-5 md:flex md:flex-col gap-5">
              <DetailItem label="Shop name">
                <span className="py-1 pl-2 block w-full text-black">
                  {User.storeName || "-"}
                </span>
              </DetailItem>

              <DetailItem label="Bio">
                <span className="py-1 pl-2 block w-full text-black">
                  {User.bio || "-"}
                </span>
              </DetailItem>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row mb-8 justify-between gap-4">
        <div className="flex gap-3 px-6">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center border-2 hover:bg-black hover:text-white border-black text-baseColor-first px-4 py-2 rounded-lg gap-2"
          >
            <MdArrowBack />
            Back
          </button>
          <button
            onClick={EditUser}
            className="flex items-center bg-buttonColor-shade6 hover:bg-buttonColor-shade7 text-white px-4 py-2 rounded-lg gap-2"
          >
            {loadingEdit ? (
              <Loading textColor={"white-0"} />
            ) : (
              <>
                <Pencil className="w-4 h-4" />
                Save Status
              </>
            )}
          </button>
        </div>
      </div>

      {showImageModal && zoomedImage && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center p-6"
          onClick={() => setShowImageModal(false)}
        >
          <button
            onClick={() => setShowImageModal(false)}
            className="absolute top-6 right-6 text-white bg-black bg-opacity-40 rounded-full p-2 hover:bg-opacity-70"
          >
            <X className="w-6 h-6" />
          </button>
          <img
            src={zoomedImage}
            alt="Zoomed"
            onClick={(e) => e.stopPropagation()}
            className="max-w-full max-h-full object-contain rounded-lg"
          />
        </div>
      )}
    </div>
  );
}

const DetailItem = ({ label, children }) => (
  <div className="flex flex-col gap-3 py-2 px-3 rounded-lg">
    <span className="text-gray-900">{label} :</span>
    <div className="text-gray-500 border-2 p-1 rounded-lg">{children}</div>
  </div>
);
